import { render, staticRenderFns } from "./TutarAraligiForm.vue?vue&type=template&id=64abeba7"
import script from "./TutarAraligiForm.vue?vue&type=script&lang=ts"
export * from "./TutarAraligiForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports